import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=32718c00"
import script from "./forgot-password.js?vue&type=script&lang=js&external"
export * from "./forgot-password.js?vue&type=script&lang=js&external"
import style0 from "./forgot-password.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports